import React, { Component } from 'react';
import __ from 'lodash';
import {connect} from 'react-redux';
import {cekCookies} from '../../../../actions';
import { CONFIG } from '../../../../config';
import accountManagement from '../../../../apis/accountManagement';
import LoaderModal from '../../../modal/LoaderModal';
import {Row, Col, Alert,Form,} from 'react-bootstrap';


class EditSoal extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            soal: {},
            isFetching: false,
            alertShow: false,
            resMessage: ''
        };
    }

    async componentDidMount() {
        document.title = "Edit Soal";
        this.setState({ isFetching: true });
        await this.props.cekCookies();
        this.fetchSoal(); 
        
        this.setState({ isFetching: false }); 
    }    

    fetchSoal = async () => {
        this.setState({ isLoading: true });
        const response = await accountManagement.get(CONFIG.SOAL_GET_BY_ID + this.props.match.params.id)
        .catch(function(error){
            console.log(error)
        });
        if(response){
            if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){                
                this.setState({
                    soal: response.data.data
                })
                
                if(!__.isEmpty(this.state.soal)){
                    window.tinyMCE.get('pertanyaan').setContent(response.data.data.pertanyaan === null ? "" : response.data.data.pertanyaan); 
                    window.tinyMCE.get('jawab1').setContent(response.data.data.jawab1 === null ? "" : response.data.data.jawab1); 
                    window.tinyMCE.get('jawab2').setContent(response.data.data.jawab2 === null ? "" : response.data.data.jawab2); 
                    window.tinyMCE.get('jawab3').setContent(response.data.data.jawab3 === null ? "" : response.data.data.jawab3); 
                    window.tinyMCE.get('jawab4').setContent(response.data.data.jawab4 === null ? "" : response.data.data.jawab4); 
                    window.tinyMCE.get('jawab5').setContent(response.data.data.jawab5 === null ? "" : response.data.data.jawab5); 
                    window.tinyMCE.get('pembahasan').setContent(response.data.data.isianJawaban === null ? "" : response.data.data.isianJawaban); 
                }                
            }
            this.setState({ isLoading: false });
        }
        
    } 

    handleChange = (e) => {        
        this.setState({
            soal: {...this.state.soal, kunciJawaban: e.target.value}
        })
    }
    
    handleSubmit = async() => {        
        if(__.isEmpty( window.tinyMCE.get('pertanyaan').getContent())) {
            this.setState({ alertShow: true, resMessage: 'Field pertanyaan harus di isi... !!'})
            window.tinyMCE.get('pertanyaan').focus()
            return false;
        }

        if( window.confirm('Konfirmasi Simpan ?')) {
            this.setState({ isFetching: true })
            const dataSend = {...this.state.soal,
                pertanyaan: window.tinyMCE.get('pertanyaan').getContent(),
                jawab1: window.tinyMCE.get('jawab1').getContent() === "" ? null : window.tinyMCE.get('jawab1').getContent(),
                jawab2: window.tinyMCE.get('jawab2').getContent() === "" ? null : window.tinyMCE.get('jawab2').getContent(),
                jawab3: window.tinyMCE.get('jawab3').getContent() === "" ? null : window.tinyMCE.get('jawab3').getContent(),
                jawab4: window.tinyMCE.get('jawab4').getContent() === "" ? null : window.tinyMCE.get('jawab4').getContent(),
                jawab5: window.tinyMCE.get('jawab5').getContent() === "" ? null : window.tinyMCE.get('jawab5').getContent(),
                isianJawaban: window.tinyMCE.get('pembahasan').getContent(),
            }    
            
            const res = await accountManagement.post(CONFIG.SOAL_EDIT_BY_ID , dataSend)
            .catch(function(error){ console.log(error) });

            if(res) {
                if(res.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                    this.props.history.push({
                        pathname: '/soal',
                        state: {idUploadHistory: this.props.match.params.iduploadhistory}
                    })
                }
                this.setState({ isFetching: false })
            }
        }       
        
    }

    handleBack() {
        if (window.confirm('Konfirmasi Keluar Page ?')) {  
            this.props.history.push({
                pathname: '/soal',
                state: {idUploadHistory: this.props.match.params.iduploadhistory}
            })
        }
    }

    render() {
        const { soal } = this.state;
        
        return (
            <div className="containerFluid" style={{paddingTop: '10px', paddingBottom: '50px'}}> 
            <LoaderModal isFetching={this.state.isFetching} />
            
            <Row style={{borderBottom: 'groove'}}>            
                <Col>
                    <button className="btn btn-danger btn-sm ml-3" onClick={() => this.handleBack()}>Back</button>
                </Col>
                <Col className="text-center"><h4>Edit Soal</h4></Col>
                <Col>
                    <button className="btn btn-primary btn-sm pull-right mr-3" onClick={this.handleSubmit}>Save</button>
                </Col>
            </Row>       
            
            {this.loadAlert()}
            
            <>
            <Col sm={12}>                                 
                <Form.Group controlId="pertanyaan">
                    <Form.Label><span>Pertanyaan: </span></Form.Label>                        
                    <textarea className="tinymce_textarea" id="pertanyaan" value="" required></textarea>    
                </Form.Group>               
                
                <Form.Group controlId="jawaban">                   
                <ul className="nav nav-tabs">
                    <li className="nav-item">
                        <a className="nav-link active" data-toggle="tab" href="#tab1">Jawaban A</a>
                    </li>                        
                    <li className="nav-item">
                        <a className="nav-link" data-toggle="tab" href="#tab2">Jawaban B</a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link" data-toggle="tab" href="#tab3">Jawaban C</a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link" data-toggle="tab" href="#tab4">Jawaban D</a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link" data-toggle="tab" href="#tab5">Jawaban E</a>
                    </li>  
                </ul>

                <div className="tab-content">
                    <div className="tab-pane active" id="tab1">
                        <textarea className="tinymce_textarea" id="jawab1" value="" required></textarea> 
                    </div>
                    <div className="tab-pane" id="tab2">
                        <textarea className="tinymce_textarea" id="jawab2" value="" required></textarea> 
                    </div>
                    <div className="tab-pane" id="tab3">
                        <textarea className="tinymce_textarea" id="jawab3" value="" required></textarea> 
                    </div>
                    <div className="tab-pane" id="tab4">
                        <textarea className="tinymce_textarea" id="jawab4" value="" required></textarea> 
                    </div>
                    <div className="tab-pane" id="tab5">
                        <textarea className="tinymce_textarea" id="jawab5" value="" required></textarea> 
                    </div>                        
                </div>
                </Form.Group>

                <Form.Group as={Row} controlId="kunci">
                    <Form.Label column sm="2"><span>Kunci Jawaban: </span></Form.Label>                        
                    <Col sm="10"> 
                    <Form.Control as="select" style={{width: '120px'}} value={soal.kunciJawaban} onChange={this.handleChange}>
                        <option value="1">A</option>
                        <option value="2">B</option>
                        <option value="3">C</option>
                        <option value="4">D</option>
                        <option value="5">E</option>
                    </Form.Control>
                    </Col>
                </Form.Group>

                <Form.Group controlId="pembahasan">
                    <Form.Label><span>Pembahasan: </span></Form.Label>                        
                    <textarea className="tinymce_textarea" id="pembahasan" value="" required></textarea>    
                </Form.Group>

            </Col> 
            </>
                   
            </div>
        );
    }

    loadAlert = () => {
        const {alertShow } = this.state;
      
        if (alertShow) {
          return (
            <Alert variant="danger" onClose={() => this.setState({ alertShow: false })} dismissible>   
                <strong>{this.state.resMessage}</strong>
            </Alert>
          );
        } 
    } 
}

const mapStateToProps = (state) => {
    return{
        account: state.account        
    };
}

export default connect(mapStateToProps, {cekCookies})(EditSoal);